<template>
	<div>
		<around :cate="1"></around>
	</div>
</template>

<script>
import around from '@/components/data/around.vue'
export default {
	components:{around},

};
</script>

<style lang="scss" scoped>
	
</style>